export default __webpack_public_path__ + "static/media/Gtr.870f8768.mp3";